import { Card } from "antd";
import { Link } from "react-router-dom";
import slugify from "slugify";
import ButtonComponent from "./button/Button";
import IconEdit from "./icons/IconEdit";

const BlogCard = ({
  date,
  readTime,
  title,
  content,
  coverImage,
  blogId,
  author,
  slug,
  newTab = false,
  handleEdit,
}) => {
  const authorSlug = slugify(author, {
    lower: true,
    strict: true,
    replacement: "-",
    remove: /[^\w\s-]/g,
  });

  return (
    <Card
      style={{
        width: "100%",
        padding: "0px",
        backgroundColor: "#fff5f0",
        height: "100%",
      }}
    >
      <Link
        to={`/blog/${authorSlug}/${slug}/${blogId}`}
        style={{ textDecoration: "none", color: "inherit" }}
        target={newTab ? "_blank" : "_self"}
        rel={newTab ? "noopener noreferrer" : undefined}
      >
        {coverImage && (
          <div
            style={{
              width: "100%",
              height: "150px",
              backgroundColor: "#fff5f0",
              marginBottom: "10px",
              borderRadius: "8px",
            }}
          >
            <img
              src={coverImage}
              alt="Blog Cover"
              style={{
                width: "100%",
                height: "150px",
                borderRadius: "8px",
                objectFit: "cover",
              }}
            />
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "12px",
            color: "#666",
          }}
        >
          <span>{date}</span>
          <span>{readTime || 0} min read</span>
        </div>
        <h3
          style={{ fontSize: "18px", fontWeight: "bold", margin: "8px 0" }}
          className="line-clamp"
        >
          {title.length > 80 ? title.slice(0, 80) + "..." : title}
        </h3>
        <p
          style={{
            fontSize: "14px",
            color: "#333",
            "--max-lines": 8,
          }}
          className="line-clamp"
        >
          {content}
        </p>
      </Link>
      {/* Edit Button */}
      {handleEdit && (
        <ButtonComponent
          onClick={(e) => {
            e.stopPropagation();
            handleEdit();
          }}
          style={{
            width: "100%",
            marginTop: "10px",
          }}
        >
          {/* Pen Icon */}
          <IconEdit style={{}} />
          Edit
        </ButtonComponent>
      )}
    </Card>
  );
};

export default BlogCard;
